import { Component, Input, inject } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { WorkflowHistoryModel } from "../../shared/models";
import { AdvEffWorkflowDataService } from "../../shared/services";
import { CerrixWorkflowHistoryGraphComponent } from "@app/shared/cerrix-workflow-history-graph/cerrix-workflow-history-graph.component";

@Component({
    selector: "eff-detail-workflow-history",
    templateUrl: "./eff-detail-workflow-history.component.html",
    styleUrls: ["./eff-detail-workflow-history.component.scss"],
    imports: [TranslocoPipe, CerrixWorkflowHistoryGraphComponent]
})
export class EffDetailWorkflowHistoryComponent {
    private _ds = inject(AdvEffWorkflowDataService);

    @Input() effectivenessGuid: string;

    workflowHistoryData: WorkflowHistoryModel[];

    private _isInitialized = false;

    init(): void {
        if (!this._isInitialized) {
            this._ds.getWorkflowHistory(this.effectivenessGuid).subscribe((data) => {
                this.workflowHistoryData = data.reverse();
                this._isInitialized = true;
            });
        }
    }
}
